import React from 'react';
import { distanceToLine } from './utils';

class Boundary {
    constructor(points, id = null, isInnerBoundary = false) {
        this.points = points;
        this.id = id || Math.random().toString(36).substr(2, 9);
        this.isInnerBoundary = isInnerBoundary;
    }

    addPoint(point) {
        const [x, y] = point;
        const lastPoint = this.points[this.points.length - 1];
        if (!lastPoint || lastPoint[0] !== x || lastPoint[1] !== y) {
            this.points.push(point);
        }
    }

    removePoint(index) {
        this.points.splice(index, 1);
    }

    move(dx, dy) {
        this.points = this.points.map(([x, y]) => [x + dx, y + dy]);
    }

    isPointNear(point, threshold) {
        if (this.points.length < 2) return false;
        const distance = distanceToLine(this.points, point);
        return distance <= threshold;
    }

    updatePoint(index, dx, dy) {
        if (index >= 0 && index < this.points.length) {
            this.points[index] = [
                this.points[index][0] + dx,
                this.points[index][1] + dy
            ];
        }
    }

    renderSVG(scale, isSelected, isHovered, isInnerBoundary = false) {
        if (this.points.length === 0) return null;
        return (
            <>
                <polygon
                    points={this.points.map(([x, y]) => `${x},${y}`).join(' ')}
                    fill={isSelected ? 'rgba(255, 0, 0, 0.3)' : (isInnerBoundary ? 'rgba(255, 255, 0, 0.3)' : 'none')}
                    stroke={this.isInnerBoundary ? 'yellow' : (isHovered ? 'orange' : (isSelected ? 'darkred' : 'black'))}
                    strokeWidth={(isSelected || isHovered) ? Math.max(4, 60 / scale) : Math.max(2, 40 / scale)}
                    strokeDasharray={this.isInnerBoundary ? '10,5' : 'none'}
                />
                {this.points.map(([x, y], index) => (
                    <circle
                        key={index}
                        cx={x}
                        cy={y}
                        r={isSelected ? Math.max(4, 60 / scale) : Math.max(2, 40 / scale)}
                        fill={this.isInnerBoundary ? 'black' : (isSelected ? 'black' : (isHovered ? 'orange' : 'red'))}
                        // stroke={this.isInnerBoundary ? 'black' : (isSelected ? 'darkred' : (isHovered ? 'orange' : 'black'))}
                        strokeWidth={Math.max(2, 40 / scale)}
                    />
                ))}
            </>
        );
    }

    clone() {
        return new Boundary(this.points.slice(), this.id, this.isInnerBoundary);
    }
}

export default Boundary;
